import React from 'react';
import usePwa from '../../hooks/usePwa';
import Button from './Button';
import Icon from './Icon';
import './UpdatePrompt.css';

const UpdatePrompt = () => {
  const { isUpdateAvailable, applyUpdate } = usePwa();

  if (!isUpdateAvailable) {
    return null;
  }

  return (
    <div className="update-prompt" role="alert">
      <div className="update-prompt__body">
        <div className="update-prompt__icon" aria-hidden="true">
          <Icon name="system_update" size="medium" />
        </div>
        <div className="update-prompt__text">
          <p className="update-prompt__title">New version ready</p>
          <p className="update-prompt__subtitle">Reload to apply the latest improvements.</p>
        </div>
      </div>
      <Button
        variant="primary"
        size="small"
        onClick={applyUpdate}
        className="update-prompt__action"
      >
        Update
      </Button>
    </div>
  );
};

export default UpdatePrompt;


